import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-tab tab-content"},[_c('div',{staticClass:"content"},[_c(VSkeletonLoader,{attrs:{"type":"article"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }